import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import {
  Navigate,
  useLocation,
  useParams,
  type RouteObject,
} from "react-router-dom";
import { getSellerPath } from "@/lib/routing/portal-urls";
import { defaultLocale } from "@/lib/i18n/portal";

/**
 * The wallet screen used to live at `/wallet`. It is now the Wallet tab of
 * `/payments`, so the old path forwards instead of 404-ing — sellers bookmark
 * this page, and the dashboard card and the wallet-short banner both pointed at
 * it for as long as it existed. The search string rides along so any deep link
 * survives the move.
 */
const PaymentsPage = lazy(() => import("./pages/PaymentsPage").then(module => ({ default: module.PaymentsPage })));
/** "Your plan" — tier, what Premium adds, its price and how to get it. */
const PlanPage = lazy(() => import("./pages/PlanPage").then(module => ({ default: module.PlanPage })));

function WalletPathRedirect() {
  const { locale = defaultLocale, storeSlug = "" } = useParams();
  const { search } = useLocation();
  return (
    <Navigate
      to={`${getSellerPath(locale, storeSlug, "/payments")}${search}`}
      replace
    />
  );
}

export const paymentsRoutes: RouteObject[] = [
  {
    path: "payments",
    element: <RouteSuspense><PaymentsPage /></RouteSuspense>,
  },
  {
    path: "wallet",
    element: <WalletPathRedirect />,
  },
  {
    path: "plan",
    element: <RouteSuspense><PlanPage /></RouteSuspense>,
  },
];
